import * as React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { toArray } from '@rc-component/util';
import { clsx } from 'clsx';
export default function useItems(prefixCls, mode, items, children, pending, pendingDot) {
    const itemCls = `${prefixCls}-item`;
    // Merge items and children
    const parseItems = React.useMemo(() => {
        return Array.isArray(items)
            ? items
            : toArray(children).map((ele) => ({
                ...ele.props,
            }));
    }, [items, children]);
    // convert legacy type
    return React.useMemo(() => {
        const mergedItems = parseItems.map((item, index) => {
            const { label, children, title, content, color, className, style, icon, dot, placement, position, loading, ...restProps } = item;
            let mergedStyle = style;
            let mergedClassName = className;
            // Color
            if (color) {
                if (['blue', 'red', 'green', 'gray'].includes(color)) {
                    mergedClassName = clsx(className, `${itemCls}-color-${color}`);
                }
                else {
                    mergedStyle = {
                        '--steps-item-icon-dot-color': color,
                        ...style,
                    };
                }
            }
            // Placement
            const mergedPlacement = placement ??
                position ??
                (mode === 'alternate' ? (index % 2 === 0 ? 'start' : 'end') : mode);
            mergedClassName = clsx(mergedClassName, `${itemCls}-placement-${mergedPlacement}`);
            // Icon
            let mergedIcon = icon ?? dot;
            if (!mergedIcon && loading) {
                mergedIcon = React.createElement(LoadingOutlined, null);
            }
            return {
                ...restProps,
                title: title ?? label,
                content: content ?? children,
                style: mergedStyle,
                className: mergedClassName,
                icon: mergedIcon,
                status: loading ? 'process' : 'finish',
            };
        });
        if (pending) {
            mergedItems.push({
                icon: pendingDot ?? React.createElement(LoadingOutlined, null),
                content: pending,
                status: 'process',
            });
        }
        return mergedItems;
    }, [parseItems, pending, pendingDot, itemCls, mode]);
}
